<template>
  <div id="view">
    <div class="historyTag">
      <historyTag :historyArr="historyArr"></historyTag>
    </div>
    <div style="height: 40px"></div>
    <div id="mainBox">
      <!-- 新增 -->
      <div class="addBanner">
        <div class="bannnerLi">
          <div class="title">账号：</div>
          <div style="width: 500px">
            <el-input
              v-model="dataList.username"
              :disabled="dataList.id ? true : false"
              type="text"
              placeholder="请输入"
            >
            </el-input>
          </div>
        </div>

        <div class="bannnerLi">
          <div class="title">密码：</div>
          <div style="width: 500px">
            <el-input v-model="dataList.password" type="text" placeholder="请输入">
            </el-input>
          </div>
        </div>

        <div class="bannnerLi">
          <el-button type="success" :disabled="submitShow" size="small" @click="submitFn"
            >保存</el-button
          >
          <!-- <el-button type="info" size="small" @click="returnFn">返回</el-button> -->
        </div>
      </div>
      <!-- 新增轮播 -->
    </div>
  </div>
</template>

<script>
import { delTips, throttle, returnPhone, returnTime, isJSON } from "@/util/utils";
import elUpload from "@/components/elUpload";
import wangEditor from "@/components/wangEditor";
export default {
  props: {
    // dataList: {
    //   type: Object,
    //   default: function () {
    //     return {
    //       username: "", //账号
    //       password: "", //密码
    //       type: 0,
    //     };
    //   },
    // },
  },
  components: {
    elUpload,
    wangEditor,
  },
  data() {
    return {
      // 历史记录
      historyArr: ["密码设置"],

      currentPage: 1,
      pageSize: 10,
      pageShow: "add",

      // 权限
      roleVle: "",
      roleInfo: [],

      //轮播列表
      submitShow: false,

      dataList: {
        username: "", //账号
        password: "", //密码
      },

      // 商务
      options: [],
      value: "",
    };
  },

  created() {},
  mounted() {
    this.selListFn(1);
  },
  //监听数据
  computed: {},
  methods: {
    // 查询
    selListFn: function (page) {
      var obj = {
        page: 1,
        size: 1,
      };

      this.$https(this.$api.api.selAccount, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          var data = res.data.data;
          this.dataList = data[0];
        }
      });
    },

    // 添加历史
    historyFn(title, str) {
      this.historyArr.push(title);
      this.pageShow = str;
    },

    // 获取图片
    addImgFn(res) {
      this.$set(this.dataList, "images", res);
    },

    // 获取时间
    getTimeFn(res) {
      let time = returnTime(res);
      this.$set(this.dataList, "fdqsj", time);
    },

    getArticleTxt(res) {
      this.$set(this.dataList, "aboutme", res);
    },

    // 提交
    submitFn: throttle(function (res) {
      let data = JSON.parse(JSON.stringify(this.dataList));
      // let roleVle = this.roleVle;

      if (!data.username) {
        this.$message.error("请填写账号");
        return;
      }

      if (!data.password) {
        this.$message.error("请填写密码");
        return;
      }

      var urls = "";
      var obj = {
        username: data.username, //账号
        password: data.password, //密码
      };

      if (data.id) {
        urls = this.$api.api.upAccount;
        obj.id = data.id;
      } else {
        urls = this.$api.api.addAccount;
      }

      this.submitShow = true;
      this.$https(urls, obj, "POST").then((res) => {
        if (res.data.code == 200) {
          this.$message.success("操作成功");
        } else {
          this.$message.error("操作失败");
        }
      });
      setTimeout((res) => {
        this.submitShow = false;
        this.returnFn();
      }, 1000);
    }),

    // 轮播返回
    returnFn: function (res) {
      this.$emit("return", {
        show: 0,
      });
    },
  },
};
</script>

<style scoped lang="less">
#mainBox {
  width: 100%;
  padding: 15px;
  box-sizing: border-box;

  // 头部
  .topBox {
    width: 100%;
    margin-bottom: 10px;
    text-align: right;
  }

  .bannerTop {
    margin-bottom: 20px;
  }

  /* 头部起始位置 */
  .el-header {
    height: 50px !important;
    line-height: 50px;
    border-bottom: 2px solid #bebebe;
  }

  .banner {
    width: 100%;
    overflow: hidden;

    .el-icon-plus,
    img {
      width: 200px;
      height: 110px;
      border: 2px dashed #dedede;
      line-height: 120px;
      text-align: center;
      font-size: 28px;
      color: #999;
    }

    .Btn {
      background: red;
      margin-left: 15px;
    }
  }

  // 轮播图列表
  .bannerImg {
    width: 180px;
    height: 70px;
    margin: auto;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .dataList {
    width: 100%;
  }

  .bannnerLi {
    width: 100%;
    margin-bottom: 25px;
    display: flex;

    .title {
      width: 110px;
      line-height: 40px;
      flex-shrink: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/Login/add.vue